function pauseMediaInSlide( slide ) {
	if ( ! slide ) {
		return;
	}

	slide.querySelectorAll( 'video, audio' ).forEach( ( media ) => {
		if ( ! media.paused ) {
			media.pause();
		}
	} );
}

function pauseMediaInInactiveSlides( swiper ) {
	swiper.slides?.forEach( ( slide, index ) => {
		if ( index !== swiper.activeIndex ) {
			pauseMediaInSlide( slide );
		}
	} );
}

function init( node ) {
	// Validate Swiper availability
	const { Swiper } = window;
	if ( ! Swiper ) {
		console.warn( 'Swiper not available. Make sure swiper is enqueued.' );
		return;
	}

	const swiper = node.querySelector( '.media-slider__swiper' );
	const nextEl = node.querySelector( '.swiper-button-next' );
	const prevEl = node.querySelector( '.swiper-button-prev' );

	const modules = [
		Swiper.Navigation,
		Swiper.A11y,
	].filter( Boolean );

	const inst = new Swiper( swiper, {
		...( modules.length > 0 && { modules } ),
		a11y: true,
		slidesPerView: 1,
		spaceBetween: '3%',
		grabCursor: false,
		speed: 300,
		navigation: {
			nextEl,
			prevEl,
		},
		breakpoints: {
			640: {
				slidesPerView: node.dataset.visibleSlides ?? 1,
			},
		},
		on: {
			slideChange() {
				pauseMediaInInactiveSlides( inst );
			},
		},
	} );

	return inst;
}

document.querySelectorAll( '.media-slider' ).forEach( init );
